module.exports = __webpack_public_path__ + "static/img/cont62 (3).d4b2059.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont62 (3).jpg
// module id = iyIy
// module chunks = 0